var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm1.042-23h2.4v3.2h-2.4a.8.8 0 0 0-.8.8v2.4h3.2l-.8 3.2h-2.4V23h-3.2v-6.4h-2.4v-3.2h2.4V11a4 4 0 0 1 4-4Z","fill":"#fff"}));
}

IconFacebookInline.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
